/**
 * @file 接口路径整理
 */

/* eslint-disable max-len */

const LIVEHOST = 'https://liveshowserv.baidu.com';
const CECOMHOST = 'https://cecom.baidu.com';

export default {
    // 获取用户信息
    GET_USER_INFO: '/ai_anchor/basis/user_info',
    PRE_CHECK_LIST: '/ai_anchor/basis/pre_rights_list',
    CHECK_REGIST_CODE: '/ai_anchor/basis/regist_code_check',
    CONFIRM_AGREEMENT: '/ai_anchor/basis/plat_agreement',
    CONFIRM_ONE_CLICK_LIVE: '/ai_anchor/basis/live_control_agreement',
    ONE_CLICK_LIVE_RESULT: '/ai_anchor/basis/live_control_agreement/result',
    WHITE_LIST: '/ai_anchor/common/white_list_all',
    CREATE_ID: '/ai_anchor/script/create_id',
    SAVE_TITLE: '/ai_anchor/script/save_title',
    PRE_CHECK: '/ai_anchor/smart_anchor/pre_check', // 发起预检查数字人像是否合规
    PRE_CHECK_RESULT: '/ai_anchor/smart_anchor/pre_check/result', // 预检查数字人像结果
    UPLOAD_BG_IMG: '/ai_anchor/bg/img_upload',
    UPLOAD_BG_VIDEO_IMG: '/ai_anchor/bg_video/upload',
    POLL_BG_UPLOAD: '/ai_anchor/bg/img_polling', // 背景图上传：轮询后端处理结果
    UPLOAD_PASTER_IMG: '/ai_anchor/paster/img_upload',
    UPLOAD_CHARACTER_FILE: '/ai_anchor/smart_anchor/upload',
    UPLOAD_AUDIO_FILE: '/ai_anchor/music/insert',
    CREATE_CHARACTER_RESOURCE: '/ai_anchor/smart_anchor/add',
    // CREATE_CHARACTER_RESOURCE_NOGREEN: 'ai_anchor/smart_anchor/save/no_green_screen',
    DEL_CHARACTER_RESOURCE: '/ai_anchor/smart_anchor/del',
    DEL_BG_IMG: '/ai_anchor/bg/status_change',
    DEL_BG_VIDEO: '/ai_anchor/bg_video/status_change',
    DEL_PASTER_IMG: '/ai_anchor/paster/status_change',
    // DEL_CHARACTER: '/ai_anchor/smart_anchor/status_change',
    DEL_AUDIO_FILE: '/ai_anchor/music/delete',
    SORT_CHARACTER: '/ai_anchor/smart_anchor/order_change',
    RENAME_CHARACTER: '/ai_anchor/smart_anchor/name_change',
    REMAKE_CHARACTER: '/ai_anchor/smart_anchor/add/confirm',
    GET_BG_LIB_LIST: '/ai_anchor/bg/list',
    GET_AI_BG_LIB_LIST: '/ai_anchor/bg/ai_list',
    GET_BG_VIDEO_LIB_LIST: '/ai_anchor/bg_video/store_list',
    GET_PASTER_LIB_LIST: '/ai_anchor/paster/store_list',
    GET_CHARACTER_LIB_LIST: '/ai_anchor/smart_anchor/list',
    GET_AI_TEMPLATE_LIST: '/ai_anchor/template/gen/list',
    GET_CHARACTER_PUB_LIST: '/ai_anchor/smart_anchor/public_list_all',
    GET_TTS_CONFIG_CONFIG: '/ai_anchor/tts/config_list',
    GET_TIMBRE_LIST: '/ai_anchor/tts/timbre_list',
    GET_MOOD_LIST: '/ai_anchor/tts/mood_list',
    GET_TEXT_AUDIO: '/ai_anchor/tts/preview',
    GET_TTS_PREVIEW_JOB: '/ai_anchor/tts/preview_job',
    GET_TTS_PREVIEW_URL: '/ai_anchor/tts/preview_res',
    GET_TTS_DURATION: '/ai_anchor/tts/duration_job',
    GET_TTS_DURATION_PROGRESS: '/ai_anchor/tts/duration_res',
    CHANGE_VOLUME: '/ai_anchor/bg_video/change_volume',
    GET_AUDIO_LIST: '/ai_anchor/music/list',
    SAVE: '/ai_anchor/script/save_layout',
    IS_FIRST_CREATE_SCRIPT: '/ai_anchor/script/create/is_first', // 是否第一次创建剧本
    DEL: '/ai_anchor/script/script_del',
    // RESERVE: `${LIVEHOST}/live/reserve_live`, // 预约直播间
    RESERVE: '/ai_anchor/live/v2/reserve_live/pre_check',
    // CANCEL_RESERVE: `${LIVEHOST}/live/close_live`, // 取消预约直播间
    CANCEL_RESERVE: '/ai_anchor/live/close_live',
    RESERVE_CONTROL: '/ai_anchor/common/live_auth_control',
    // CLOSE_ROOM: `${LIVEHOST}/live/close_room`, // 关播
    CLOSE_ROOM: '/ai_anchor/live/close_room',
    GET_LIVE_STATUS: '/ai_anchor/live/status',
    GET_LIVE_CATEGORY: '/ai_anchor/live/get_category',
    GET_SCRIPT_LIST: '/ai_anchor/script/get_list',
    GET_SCRIPT_DETAIL: '/ai_anchor/script/cat_layout',
    GET_STS_CONFIG: '/ai_anchor/common/tst_config',
    GET_CAST_ID: '/ai_anchor/common/im/get_mcast_id',
    GET_ERNIE_TEXT: '/ai_anchor/script/wenxin_chat', // 辅写接口
    GET_ERNIE_TEXT_V2: '/ai_anchor/script/ai/v2/auxiliary_write', // 辅写新版接口
    GET_ERNIE_LIVE_TITLE: '/ai_anchor/live/wenxin_live_title',
    GET_ERNIE_LIVE_DESC: '/ai_anchor/live/wenxin_live_desc',
    GET_ERNIE_LIVE_LABEL: '/ai_anchor/live/wenxin_live_label',
    GET_PREVIEW_FLOW: '/ai_anchor/script/preview',
    GET_V2_FAQ_QUESTION_TYPE_ADD: '/ai_anchor/qa/v2/qustion_type/add_goods', // 添加商品问答库
    GET_V2_FAQ_QUESTION_TYPE_DEL: '/ai_anchor/qa/v2/question_type/delete', // 添加商品问答库

    GET_V2_FAQ_QUESTION_TYPE: '/ai_anchor/qa/v2/question_type/list', // 商品问答库类型
    UPDATE_V2_FAQ: '/ai_anchor/qa/v2/update', // 移动问答对
    GET_V2_FAQ: '/ai_anchor/qa/v2/list', // 商品库问答列表
    ADD_V2_FAQ: '/ai_anchor/qa/v2/add', // 添加问答对到商品库
    DEL_V2_FAQ: '/ai_anchor/qa/v2/delete', // 删除问答对

    GET_FAQ: '/ai_anchor/qa/list', // 商品库问答列表
    DEL_FAQ: '/ai_anchor/qa/delete',
    ADD_FAQ: '/ai_anchor/qa/add',
    UPDATE_FAQ: '/ai_anchor/qa/update',
    ENABLE_FAQ: '/ai_anchor/qa/enable',
    DISABLE_FAQ: '/ai_anchor/qa/disable',
    ERNIE_SCRIPT_FAQ: '/ai_anchor/qa/script_wenxin_switch',
    ERNIE_GOODS_FAQ: '/ai_anchor/qa/goods_wenxin_switch',
    ERNIE_CUSTOM_FAQ: '/ai_anchor/qa/customer_acquisition_wenxin_switch', // ai生成线索
    ERNIE_FAQ_PROGRESS: '/ai_anchor/qa/progress_query',
    ERNIE_FAQ_LIST: '/ai_anchor/qa/ai_list',
    ERNIE_FAQ_USE_UPDATE: '/ai_anchor/qa/ai_use_update',
    ERNIE_FAQ_SETTING: '/ai_anchor/qa/setup',
    GET_ERNIE_FAQ_SETTING: '/ai_anchor/qa/setup_query',
    CHECK_FAQ_BYFILE: '/ai_anchor/qa/add/check/file',
    CHECK_FAQ: '/ai_anchor/qa/add/check',
    GET_INTERACT_RULES: '/proxy/script_center/interact/rule/get',
    SAVE_INTERACT_RULES: '/proxy/script_center/interact/rule/save',
    GET_INITIAL_RESERVE_FORM: '/ai_anchor/live/info_review_r',
    SET_INITIAL_RESERVE_FORM: '/ai_anchor/live/info_review_w',
    SCRIPT_IS_USE: '/ai_anchor/smart_anchor/is_use',
    GET_TTS_PREVIEW_AUTH: '/ai_anchor/tts/check_auth',
    SET_CHARACTER_OPTIONS: '/ai_anchor/smart_anchor/master_page_save',
    GET_CHARACTER_OPTIONS: '/ai_anchor/smart_anchor/master_page_query',
    SAVE_CHARACTER_NAME: '/ai_anchor/smart_anchor/master_page_update_name',
    CREATE_AIGC_SCRIPT: '/ai_anchor/script/goods_wenxin_switch', // ai生成脚本
    CREATE_CUSTOM_SCRIPT_V2: '/ai_anchor/script/customer_acquisition_wenxin_switch', // ai生成脚本
    CREATE_AIGC_SCRIPT_V2: '/ai_anchor/script/ai/v2/create', // ai生成脚本
    GET_AIGC_SCRIPT_PROGRESS: '/ai_anchor/script/progress_query', // ai生成脚本进度
    GET_AIGC_SCRIPT_PROGRESS_V2: '/ai_anchor/script/ai/v2/progress', // ai生成脚本进度
    GET_AIGC_SCRIPT_RESULT: '/ai_anchor/script/ai_list', // ai生成脚本结果
    GET_AIGC_SCRIPT_RESULT_V2: '/ai_anchor/script/ai/v2/res', // ai生成脚本结果
    SET_AIGC_SCRIPT_RESULT_USE: '/ai_anchor/script/ai_use_update',
    ACCEPT_AIGC_SCRIPT_LOG: '/ai_anchor/feedback/aigc/script', // ai生成脚本 服务端埋点
    ACCEPT_AIGC_SCRIPT_LOG_V2: '/ai_anchor/script/ai/v2/user_action', // ai生成脚本 服务端埋点
    GET_UNREAD_COUNT: '/ai_anchor/notice_center/unread_num',
    GET_NOTICE_LIST: '/ai_anchor/notice_center/list',
    READ_NOTICE: '/ai_anchor/notice_center/set_read',
    DEL_NOTICE: '/ai_anchor/notice_center/del',
    GET_BANNER_LIST: '/ai_anchor/banner/list', // 获取banner列表
    GET_SPU_IMG_LIST: '/ai_anchor/bg/spu_img_list',
    GET_AIGC_IMG_MOOD_LIST: '/ai_anchor/bg/mode_list ',
    GET_AIGC_IMG_STYLE_IDS: '/ai_anchor/bg/mode_operator_list',
    SET_AIGC_IMG_UPLOAD: '/ai_anchor/sdk/upload_img',
    SET_AIGC_IMG_TRANS: '/ai_anchor/sdk/trans_img',
    CREATE_AIGC_IMG: '/ai_anchor/bg/mode_img_create',
    CLIP_INIT_AIGC_IMG: '/ai_anchor/bg/segmentation',
    CLIP_AIGC_IMG: '/ai_anchor/bg/clip',
    GET_TTS_LIST: '/ai_anchor/tts/tts_list',

    SET_LIVE_PUSH_START: '/ai_anchor/external_room/config/start', // 开始推流
    SAVE_AND_PUSH_LIVE: '/ai_anchor/external_room/config/save', // 保存并推流
    GET_LIVE_PUSH_DETAIL: '/ai_anchor/external_room/config/info', // 获取推流详情
    SET_LIVE_PUSH_STOP: '/ai_anchor/external_room/config/stop', // 停止推流
    SET_PUSH_LIVE_AGREE: '/ai_anchor/external_room/agreement/save', // 推流授权
    GET_PUSH_LIVE_AGREE: '/ai_anchor/external_room/agreement/get', // 推流授权详情
    GET_VIRTUAL_CAMERA_STATUS: 'http://localhost:19000/status', // 获取拉流助手状态
    SET_VIRTUAL_CAMERA_START: 'http://localhost:19000/start', // 开启拉流助手
    SET_VIRTUAL_CAMERA_STOP: 'http://localhost:19000/stop', // 关闭拉流助手
    GET_VIRTUAL_CAMERA_CONFIG: '/ai_anchor/external_room/config/vcam', // 获取拉流助手配置
    SET_LIVE_PUSH_LOG: '/ai_anchor/external_room/log', // 站外直播日志
    SET_OUTSIDE_LIVE_ROOM: '/ai_anchor/external_room/interact/save', // 保存外部直播间&抓取
    GET_EXTERNAL_SIGN: '/ai_anchor/open/xl/auth/sign', // 获取对外插件签名
    GET_EXTERNAL_AUTH_LIST: '/ai_anchor/open/xl/auth/list', // 获取对外授权列表
    GET_EXTERNAL_AUTH_JUMP_URL: '/ai_anchor/open/xl/auth/start', // 获取对外开启授权跳转链接
    REPORT_EXTERNAL_AUTH_STATUS: '/ai_anchor/open/xl/auth/report', // 上报对外授权状态
    GET_EXTERNAL_GOODS_LIST: '/ai_anchor/open/xl/goods/list', // 获取对外商品列表
    UPLOAD_EXTERNAL_GOODS: '/ai_anchor/open/xl/goods/report', // 上传对外商品
    SET_AIGC_SCRIPT_RESULT_CHECK: '/ai_anchor/script/check',
    GET_AIGC_SCRIPT_WENXIN_PROMPTS: '/ai_anchor/script/wenxin_prompts',
    GET_TTS_CLONE_LIST: '/ai_anchor/tts/tts_clone_list',
    UPDATE_TTS_CLONE: '/ai_anchor/tts/tts_clone_update',
    TEMPLATE_LIST: '/ai_anchor/template/list',
    PUB_TEMPLATE_LIST: '/ai_anchor/template/public/list',
    TEMPLATE_CREATE: '/ai_anchor/template/create',
    TEMPLATE_SAVE: '/ai_anchor/template/save',
    TEMPLATE_DEL: 'ai_anchor/template/del',
    CREATE_VIDEO: '/ai_anchor/script/record_video/gen',
    CANCEL_VIDEO: '/ai_anchor/script/record_video/gen_cancel', // 取消生成
    IS_SHOW_FAQ_ERNIE_AUTH: '/ai_anchor/live/is_show_qa_authorized',
    TRANS_IMAGE: `${CECOMHOST}/proxy/trans_image?access_name=cecom_fe&ak=cecom_fe&expire=1700448951&sign=ae23399260c3bfd521c8740971258433`,
    CUT_BACKGROUND_VIDEO: '/ai_anchor/bg_video/cut', // 截取背景视频
    CUT_BACKGROUND_VIDEO_PROGRESS: '/ai_anchor/bg_video/cut_msg',
    CUT_BACKGROUND_VIDEO_BATCH: '/ai_anchor/bg_video/batch_cut_msg', // 批量截取背景视频
    GET_PUBLIC_PASTER: '/ai_anchor/paster/public_paster_list',
    GET_PASTER_CATEGORY: '/ai_anchor/paster/category_list',
    CHECK_VIDEO_CAN_PUSH: '/ai_anchor/script/record_video/can_put_in',
    VIDEO_PUSH: '/ai_anchor/script/record_video/put_in',
    GET_FAQ_OPTIMIZE_NUM: '/ai_anchor/qa_optimize/get_num',
    GET_FAQ_OPTIMIZE_LIST: '/ai_anchor/qa_optimize/to_optimize',
    GET_FAQ_OPTIMIZE_MARK: '/ai_anchor/qa_optimize/status_change',
    ADD_FAQ_OPTIMIZE: '/ai_anchor/qa_optimize/add_library',
    SET_SUGGESTION_FEEDBACK: '/ai_anchor/optim/feedback', // 剧本优化建议回馈
    FAQ_MARK_EXIT: '/ai_anchor/qa_optimize/exit',
    GET_PASTER_GROUP_LIST: '/ai_anchor/paster/group_list',
    QUERY_PROGRESS: '/ai_anchor/round/info',
    GET_TTS_TAG_LIST: '/ai_anchor/public/multiple_category/list', // 获取TTS标签列表
    GET_TTS_COLLECTION_LIST: '/ai_anchor/user/collection/list', // 获取TTS收藏列表
    GET_TTS_COLLECTION_ADD: '/ai_anchor/user/collection/add', // 添加TTS收藏
    GET_TTS_COLLECTION_DEL: '/ai_anchor/user/collection/del', // 删除TTS收藏
    GET_TTS_SWAN_LIST: '/ai_anchor/tts/swan_list', // 获取TTS收音定制列表
    SET_MEDIA_INFO: '/ai_anchor/supplier/create',
    SET_MOBILE_MANAGER_INFO: '/ai_anchor/mobile/manager/info',
    FAQ_RECOMMEND_LIST: '/ai_anchor/qa/v2/recommend/list', // 推荐问答列表
    AI_ANSWER_TOTAL: '/ai_anchor/qa/v2/ai_answer/total_num', // 智能回复问答总数
    AI_ANSWER_PAGE: '/ai_anchor/qa/v2/ai_answer/page', // 推荐问答列表
    FEED_BACK_ANCHOR: '/ai_anchor/smart_anchor/email/feedback',
    GET_CHARACTER_COLLECTION_LIST: '/ai_anchor/user/collection/list',
    ADD_CHARACTER_COLLECTION: '/ai_anchor/user/collection/add',
    DEL_CHARACTER_COLLECTION: '/ai_anchor/user/collection/del',
    GET_NOTICE_CAROUSEL_LIST: '/ai_anchor/notice_center/carousel_list', // 轮播公告列表
    GET_AGREEMENT_CONTENT: '/ai_anchor/script/experiment/agreement_content', // 轮播公告 协议详情
    AGREEMENT_ACTION: '/ai_anchor/script/experiment/agreement/action', // 轮播公告 操作协议
    GET_NOTICE_POP_LIST: '/ai_anchor/notice_center/pop_list', // 弹窗公告列表
    SCRIPT_RISK_CHECK: '/ai_anchor/audit/script/result',
    SUBMIT_ASR_JOB: '/ai_anchor/media/asr/add',
    SUBMIT_ASR_DETAIL: '/ai_anchor/media/asr/get',
    SCHOOL_LIST: '/ai_anchor/school/get_content', // 学习中心列表
    GET_TEMPLATE_BY_ID: '/ai_anchor/template/gen/search',
    PRE_CHECK_FEED_BACK: '/ai_anchor/smart_anchor/face_feedback', // 形象上传预检反馈
    CHECK_SAYAS: '/ai_anchor/script/check_pronunciation',

    GET_FONT_LIST: '/ai_anchor/script/fonts/font',
    GET_FONT_STYLE_LIST: '/ai_anchor/script/fonts/style',
    CAN_GEN_SCRIPT: '/ai_anchor/script/can_gen_script', // 判断是否是度小店商品
    // 脚本工具
    GET_SCRIPT_ADD: '/ai_anchor/script/script_tool/add', // 添加脚本库
    GET_SCRIPT_LIB_LIST: '/ai_anchor/script/script_tool/list', // 获取脚本列表
    GET_SCRIPT_INFO: '/ai_anchor/script/script_tool/get', // 获取脚本详情信息
    GET_SCRIPT_DEL: '/ai_anchor/script/script_tool/del', // 删除某一个脚本
    GET_FPLLOW_STYLE_LIST: '/ai_anchor/script/script_tool/follow_style_list', // 风格列表
    GET_GENERATE_START: '/ai_anchor/script/ai/v3/create', // 生成剧本
    GET_GENERATE_RES: '/ai_anchor/script/ai/v3/res', // 获取生成结果
    GET_ASR_DETAIL: '/ai_anchor/script/script_tool/asr/info',
    GET_GOODS_MSG: '/ai_anchor/script/script_tool/goods_msg/get', // 根据商品获取商品详情 ocr信息

    SCRIPT_CENTER_SNAPSHOT: '/ai_anchor/data/script_create/snapshot',
    GET_SCRIPT_CENTER_SNAPSHOT: '/ai_anchor/data/script_create/snapshot/read',
    GET_RECOMMEND_PASTER: '/ai_anchor/user_history/recommend/paster',
    GET_RECOMMEND_VIDEO: '/ai_anchor/user_history/recommend/video',
    PPT_ANALYSIS: '/ai_anchor/script/file2jpg',
    PPT_ANALYSIS_RESULT: '/ai_anchor/script/file2jpg/result',
    PPT_AI_MATCH: '/ai_anchor/script/ppt_word_match',
    PPT_AI_MATCH_RESULT: '/ai_anchor/script/ppt_word_match/result',
    GET_PUBLIC_PASTER_CATEGORY: '/ai_anchor/paster/public_paster_categorys', // 获取公共素材库分类

    // 新手引导
    GET_USER_GUIDE: '/ai_anchor/user_history/guide/status/get',
    SET_USER_GUIDE: '/ai_anchor/user_history/guide/status/set',

    GET_GOODS_INFO: '/ai_anchor/common/goods/query', // 获取商品信息
    GET_PASTER_RECOMMEND: '/ai_anchor/paster/get_recommend_paster',

    // 线索相关
    CHECK_CUSTOM_ACQ: '/ai_anchor/script/check_customer_acquisition', // 检查是否可以添加新的线索
    GET_QA_IMAGE: '/ai_anchor/qa/v2/picture/show'
};
